// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/modules/products/v2_0/components/CompareBucketRedux/components/CompareBucket.scss
// module id = 1405
// module chunks = 10